module.exports = "/fonts/vendor/cryptocoins-icons/webcryptocoins.ttf?284a85febc6652ce35b2ca344c2aae49";